//roles.jsx
// keys need to match backend role values

export const ROLES = {
  admin: {
    order: 1,
    i18nKey: "roles.admin",
  },
  // "isit-user-employee": {
  //   order: 2,
  //   i18nKey: "roles.isit-user-employee"
  // },
  // anonymizer: {
  //   order: 3,
  //   i18nKey: "roles.anonymizer"
  // },
  user: {
    order: 4,
    i18nKey: "roles.user"
  }
};
